module.exports = "images/location_art.3347d2f256489225a9f9d53e92b4e889.png";